import { EmergencyCartState } from "@dana/Store/Data/EmergencyCart/EmergencyCartState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: EmergencyCartState = {
    isLoading: false,
    loadSuccess: false,
    cart: null,
    errorMessage: '',
};

const reducer = createTypedReducerWithImmer(initialState, {
   "EmergencyCart/Start": (draft: Draft<EmergencyCartState>) => {
    draft.isLoading = true;   
    draft.loadSuccess = false;
},
  "EmergencyCart/LoadResponse": (draft, action: any) => {    
    if (action.cart) {
        draft.cart = { ...action.cart };
        draft.loadSuccess = true;
    }
    draft.isLoading = false;
},
    "EmergencyCart/End": (draft: Draft<EmergencyCartState>, action: any) => {
        draft.isLoading = false;
        // Only set success true if we actually have a cart
        draft.loadSuccess = !!draft.cart;
    }
});

(reducers as any).emergencyCartState = reducer;

type EmergencyCartReducers = {
    emergencyCartState: typeof reducer;
};

export type EmergencyCartActions = Parameters<EmergencyCartReducers[keyof EmergencyCartReducers]>[1] | AnyAction;